/**
 * Brand configuration for multi-site deployment
 * Each brand contains the specific configuration for a different branded site
 */
const brands = {
  ezseat: {
    name: 'EZseat',
    domain: 'ezseat.asia',
    assets: {
      logo: '/brands/ezseat/images/ezseat_logo.webp',
      favicon: '/brands/ezseat/favicon/favicon.ico',
      favicon16: '/brands/ezseat/favicon/favicon-16x16.webp',
      favicon32: '/brands/ezseat/favicon/favicon-32x32.webp',
      appleTouchIcon: '/brands/ezseat/favicon/apple-touch-icon.webp',
      safariPinnedTab: '/brands/ezseat/favicon/safari-pinned-tab.svg',
      background: '/brands/ezseat/images/backgrounds/header_bg.webp'
    },
    // Google Tag configuration
    trackingConfig: {
      gtmId: 'G-FQHS74LFDS',
      adWordsId: 'AW-16906610079',
      conversionId: 'gKRxCJGtvqoaEJ_L2f0-'
    },
    primaryColor: '#ff6600', // Orange color from existing site
    themeColor: '#ff6600',
    metaTitle: 'จองตั๋วรถทัวร์ออนไลน์',
    metaDescription: 'จองตั๋วรถทัวร์ออนไลน์ทั่วไทยกับ EZseat เลือกที่นั่งได้เอง ราคาถูก ปลอดภัย ใช้งานง่าย',
    metaKeywords: 'จองตั๋วรถทัวร์,ตั๋วรถทัวร์,จองตั๋วรถทัวร์ออนไลน์,ตั๋วรถทัวร์ออนไลน์',
    mainHeading: 'จองตั๋วรถทัวร์ออนไลน์ทั่วไทยกับ EZseat', // H1 heading for homepage
    socialLinks: [
      'https://www.facebook.com/profile.php?id=61573656926936',
      'https://line.me/R/ti/p/@363fpekv?ts=03281359&oat_content=url'
    ]
  },
  bookingrongthai: {
    name: 'BookingRongThai',
    domain: 'bookingrongthai.com',
    assets: {
      logo: '/brands/bookingrongthai/images/bookingrongthai_logo.webp',
      favicon: '/brands/bookingrongthai/favicon/favicon.ico',
      favicon16: '/brands/bookingrongthai/favicon/favicon-16x16.webp',
      favicon32: '/brands/bookingrongthai/favicon/favicon-32x32.webp',
      appleTouchIcon: '/brands/bookingrongthai/favicon/apple-touch-icon.webp',
      safariPinnedTab: '/brands/bookingrongthai/favicon/safari-pinned-tab.svg',
      background: '/brands/bookingrongthai/images/backgrounds/header_bg.webp'
    },
    // Google Tag configuration
    trackingConfig: {
      gtmId: 'G-Q251NYG2Z1',
      adWordsId: 'AW-16906610079',
      conversionId: 'PLACEHOLDER1' // Replace with actual conversion ID when available
    },
    primaryColor: '#e74c3c',
    themeColor: '#e74c3c',
    metaTitle: 'จองตั๋วรถทัวร์ออนไลน์ - BookingRongThai',
    metaDescription: 'จองตั๋วรถทัวร์ออนไลน์ง่ายๆกับ BookingRongThai เลือกที่นั่งได้เอง ราคาถูก ปลอดภัย',
    metaKeywords: 'จองตั๋วรถทัวร์,ตั๋วรถทัวร์,จองตั๋วรถทัวร์ออนไลน์,ตั๋วรถทัวร์ออนไลน์',
    mainHeading: 'จองตั๋วรถทัวร์ออนไลน์ง่ายๆกับ BookingRongThai',
    socialLinks: []
  },
  tuathaionline: {
    name: 'TuaThaiOnline',
    domain: 'tuathaionline.com',
    assets: {
      logo: '/brands/tuathaionline/images/tuathaionline_logo.webp',
      favicon: '/brands/tuathaionline/favicon/favicon.ico',
      favicon16: '/brands/tuathaionline/favicon/favicon-16x16.webp',
      favicon32: '/brands/tuathaionline/favicon/favicon-32x32.webp',
      appleTouchIcon: '/brands/tuathaionline/favicon/apple-touch-icon.webp',
      safariPinnedTab: '/brands/tuathaionline/favicon/safari-pinned-tab.svg',
      background: '/brands/tuathaionline/images/backgrounds/header_bg.webp'
    },
    // Google Tag configuration
    trackingConfig: {
      gtmId: 'G-ZZGN1GC52R',
      adWordsId: 'AW-16906610079',
      conversionId: 'PLACEHOLDER2' // Replace with actual conversion ID when available
    },
    primaryColor: '#2ecc71',
    themeColor: '#2ecc71',
    metaTitle: 'จองตั๋วรถทัวร์ออนไลน์ - TuaThaiOnline',
    metaDescription: 'จองตั๋วรถทัวร์ออนไลน์ง่ายๆกับ TuaThaiOnline เลือกที่นั่งได้เอง ราคาถูก ปลอดภัย',
    metaKeywords: 'จองตั๋วรถทัวร์,ตั๋วรถทัวร์,จองตั๋วรถทัวร์ออนไลน์,ตั๋วรถทัวร์ออนไลน์',
    mainHeading: 'จองตั๋วรถทัวร์ออนไลน์ง่ายๆกับ TuaThaiOnline',
    socialLinks: []
  },
  jongtuathai: {
    name: 'JongTuaThai',
    domain: 'jongtuathai.com',
    assets: {
      logo: '/brands/jongtuathai/images/jongtuathai_logo.webp',
      favicon: '/brands/jongtuathai/favicon/favicon.ico',
      favicon16: '/brands/jongtuathai/favicon/favicon-16x16.webp',
      favicon32: '/brands/jongtuathai/favicon/favicon-32x32.webp',
      appleTouchIcon: '/brands/jongtuathai/favicon/apple-touch-icon.webp',
      safariPinnedTab: '/brands/jongtuathai/favicon/safari-pinned-tab.svg',
      background: '/brands/jongtuathai/images/backgrounds/header_bg.webp'
    },
    // Google Tag configuration
    trackingConfig: {
      gtmId: 'G-GW41BDH9RT',
      adWordsId: 'AW-16906610079',
      conversionId: 'PLACEHOLDER4' // Replace with actual conversion ID when available
    },
    primaryColor: '#9b59b6',
    themeColor: '#9b59b6',
    metaTitle: 'จองตั๋วรถทัวร์ออนไลน์ - JongTuaThai',
    metaDescription: 'จองตั๋วรถทัวร์ออนไลน์ง่ายๆกับ JongTuaThai เลือกที่นั่งได้เอง ราคาถูก ปลอดภัย',
    metaKeywords: 'จองตั๋วรถทัวร์,ตั๋วรถทัวร์,จองตั๋วรถทัวร์ออนไลน์,ตั๋วรถทัวร์ออนไลน์',
    mainHeading: 'จองตั๋วรถทัวร์ออนไลน์ง่ายๆกับ JongTuaThai',
    socialLinks: []
  },
  jongtuaonline: {
    name: 'JongTuaOnline',
    domain: 'jongtuaonline.com',
    assets: {
      logo: '/brands/jongtuaonline/images/jongtuaonline_logo.webp',
      favicon: '/brands/jongtuaonline/favicon/favicon.ico',
      favicon16: '/brands/jongtuaonline/favicon/favicon-16x16.webp',
      favicon32: '/brands/jongtuaonline/favicon/favicon-32x32.webp',
      appleTouchIcon: '/brands/jongtuaonline/favicon/apple-touch-icon.webp',
      safariPinnedTab: '/brands/jongtuaonline/favicon/safari-pinned-tab.svg',
      background: '/brands/jongtuaonline/images/backgrounds/header_bg.webp'
    },
    // Google Tag configuration
    trackingConfig: {
      gtmId: 'G-6P5YNG7WJQ',
      adWordsId: 'AW-16906610079',
      conversionId: 'PLACEHOLDER5' // Replace with actual conversion ID when available
    },
    primaryColor: '#3498db',
    themeColor: '#3498db',
    metaTitle: 'จองตั๋วรถทัวร์ออนไลน์ - JongTuaOnline',
    metaDescription: 'จองตั๋วรถทัวร์ออนไลน์ง่ายๆกับ JongTuaOnline เลือกที่นั่งได้เอง ราคาถูก ปลอดภัย',
    metaKeywords: 'จองตั๋วรถทัวร์,ตั๋วรถทัวร์,จองตั๋วรถทัวร์ออนไลน์,ตั๋วรถทัวร์ออนไลน์',
    mainHeading: 'จองตั๋วรถทัวร์ออนไลน์ง่ายๆกับ JongTuaOnline',
    socialLinks: []
  }
};

const getCurrentBrand = () => {
  const brandKey = process.env.REACT_APP_BRAND || 'ezseat';
  const selectedBrand = brands[brandKey] || brands.ezseat;

  // Create a new object with environment variables taking precedence
  return {
    ...selectedBrand,
    name: process.env.REACT_APP_BRAND_NAME || selectedBrand.name,
    // Always use the configured domain or environment variable
    domain: process.env.REACT_APP_DOMAIN || selectedBrand.domain,
    themeColor: process.env.REACT_APP_THEME_COLOR || selectedBrand.themeColor,
    metaTitle: process.env.REACT_APP_META_TITLE || selectedBrand.metaTitle,
    metaDescription: process.env.REACT_APP_META_DESCRIPTION || selectedBrand.metaDescription,
    metaKeywords: process.env.REACT_APP_META_KEYWORDS || selectedBrand.metaKeywords,
    mainHeading: process.env.REACT_APP_MAIN_HEADING || selectedBrand.mainHeading,
    // Add tracking configuration values with environment variables taking precedence
    trackingConfig: {
      gtmId: process.env.REACT_APP_GTM_ID || selectedBrand.trackingConfig?.gtmId,
      adWordsId: process.env.REACT_APP_ADWORDS_ID || selectedBrand.trackingConfig?.adWordsId,
      conversionId: process.env.REACT_APP_CONVERSION_ID || selectedBrand.trackingConfig?.conversionId
    }
  };
};

module.exports = {
  brands,
  getCurrentBrand
};